import { useQuery } from '@tanstack/react-query';
import {
  getApiV1MetadataSmdaMetadataCountries,
  getApiV1MetadataSmdaMetadataFields,
  getApiV1MetadataSmdaMetadataStratigraphicColumns,
  getApiV1MetadataSmdaMetadataStratigraphicUnits,
} from '../api/generated';
import { useAccessToken } from '../auth/AccessTokenContext';
import { queryKeys } from './queryKeys';

export const useFetchSmdaCountries = () => {
  const token = useAccessToken();

  const query = useQuery({
    queryKey: queryKeys.smdaCountries(),
    queryFn: () => getApiV1MetadataSmdaMetadataCountries(),
    select: (res) => res.data?.data ?? [],
    enabled: !!token,
    staleTime: 10 * 60 * 1000,
  });

  return query;
};

export const useFetchSmdaFields = () => {
  const token = useAccessToken();

  const query = useQuery({
    queryKey: queryKeys.smdaFields(),
    queryFn: () => getApiV1MetadataSmdaMetadataFields(),
    select: (res) => res.data?.data ?? [],
    enabled: !!token,
    staleTime: 10 * 60 * 1000,
  });

  return query;
};

export const useFetchSmdaStratigraphicColumns = () => {
  const token = useAccessToken();

  const query = useQuery({
    queryKey: queryKeys.smdaStratColumns(),
    queryFn: () => getApiV1MetadataSmdaMetadataStratigraphicColumns(),
    select: (res) => res.data?.data ?? [],
    enabled: !!token,
    staleTime: 10 * 60 * 1000,
  });

  return query;
};

export const useFetchSmdaMetadataStratigraphicUnits = () => {
  const token = useAccessToken();

  const query = useQuery({
    queryKey: queryKeys.smdaStratUnits(),
    queryFn: () => getApiV1MetadataSmdaMetadataStratigraphicUnits(),
    select: (res) => res.data?.data ?? [],
    enabled: !!token,
    staleTime: 10 * 60 * 1000,
  });

  return query;
};
